class StickyVariantPicker extends HTMLElement {
  constructor() {
    super();

    this.selects = this.querySelectorAll('select');
    this.mainProduct = this.closest('.shopify-section--main-product');
    this.mainProductVariantPicker = this.mainProduct?.querySelector('variant-picker');
    this.optionValues = Array.from(this.mainProductVariantPicker?.querySelectorAll('input[data-option-value]') || []);

    if(this.selects.length == 0) console.error('StickyVariantPicker: No selects found');

    if(this.optionValues.length == 0) console.error('StickyVariantPicker: No option values found');

    this.selects.forEach(select => select.addEventListener('change', this.handleSelectChange.bind(this)));
  }
  handleSelectChange(event) {
    let value = event.target.value;
    let optionValue = this.optionValues.find(input => input.dataset.optionValue === value);
    
    if(optionValue) {
        optionValue.checked = true;
        optionValue.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
        console.error('StickyVariantPicker: Option value not found', value);
    }
  }
}

customElements.define('sticky-variant-picker', StickyVariantPicker);

class StickyQuantitySelector extends HTMLElement {
  constructor() {
    super();

    this.quantitySelector = this.querySelector('.quantity-selector-sticky');
    this.minusBtn = this.quantitySelector?.querySelector('.quantity-minus');
    this.plusBtn = this.quantitySelector?.querySelector('.quantity-plus');
    this.quantityValue = this.quantitySelector?.querySelector('.quantity-value');
    this.mainProduct = this.closest('.shopify-section--main-product');
    this.mainProductQuantity = this.mainProduct?.querySelector('.quantity-selector__input');

    // Set up event listeners
    this.minusBtn?.addEventListener('click', this.handleMinusClick.bind(this));
    this.plusBtn?.addEventListener('click', this.handlePlusClick.bind(this));

    // Initialize the display - read current value dynamically
    this.currentQuantity = parseInt(this.quantityValue?.value) || 1;
    this.updateQuantity();
  }

  handleMinusClick() {
    // Read current value dynamically as it may have been updated elsewhere
    this.currentQuantity = parseInt(this.quantityValue?.value) || 1;

    if (this.currentQuantity > 1) {
      this.currentQuantity--;
      this.updateQuantity();
    }
  }

  handlePlusClick() {
    // Read current value dynamically as it may have been updated elsewhere
    this.currentQuantity = parseInt(this.quantityValue?.value) || 1;
    this.currentQuantity++;
    this.updateQuantity();
  }

  updateQuantity() {
    // Update the sticky bar quantity value
    if (this.quantityValue) {
      this.quantityValue.value = this.currentQuantity;
    }
    
    // Disable minus button if quantity is 1
    if (this.minusBtn) {
      this.minusBtn.disabled = this.currentQuantity <= 1;
    }

    // Sync with main product quantity input
    if (this.mainProductQuantity) {
      this.mainProductQuantity.value = this.currentQuantity;
      
      // Sync the main product quantity selector minus button state
      const mainQuantitySelector = this.mainProduct?.querySelector('quantity-selector');
      // Get the first button (minus/decrease button) - it could be either a button or anchor tag
      const mainMinusButton = mainQuantitySelector?.querySelectorAll('.quantity-selector__button')[0];
      
      if (mainMinusButton) {
        // Enable/disable based on quantity (disable if quantity is at minimum)
        const minValue = parseInt(this.mainProductQuantity.min) || 1;
        if (this.currentQuantity <= minValue) {
          mainMinusButton.setAttribute('disabled', 'disabled');
        } else {
          mainMinusButton.removeAttribute('disabled');
        }
      }
      
      this.mainProductQuantity.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

customElements.define('sticky-quantity-selector', StickyQuantitySelector);